import OfflineDocumentsList from './OfflineDocumentsList';

export default OfflineDocumentsList;
